import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'syngenta-digital-cropwise-react-ui-kit';
import Button, {
  ButtonType
} from 'syngenta-digital-cropwise-react-ui-kit/dist/components/button';
import ErrorIcon from 'assets/error-circle-outline.svg?react';
import WarningIcon from 'assets/warning.svg?react';
import InfoIcon from 'assets/info.svg?react';
import CheckIcon from 'assets/green-circle-check.svg?react';

const confirmModalDefaultOnConfirm = () => {};

const TITLE_ICONS = {
  confirmation: CheckIcon,
  warning: WarningIcon,
  warningConfirmation: WarningIcon,
  information: InfoIcon,
  error: ErrorIcon
};

const renderTitle = (title, type) => {
  if (!title) {
    return null;
  }
  const Icon = TITLE_ICONS[type];
  return (
    <span className="organizations-confirm-modal__title">
      {Icon && <Icon width={24} height={24} />}
      {title}
    </span>
  );
};

const ConfirmModal = ({
  children,
  close,
  open,
  title = null,
  onConfirm = confirmModalDefaultOnConfirm,
  onCancel = null,
  confirmLabel = 'Ok',
  cancelLabel = 'Cancel',
  isSaving = false,
  type = 'basic'
}) => {
  const handleCancelClick = onCancel ?? close;
  const hasIcon = Boolean(title && TITLE_ICONS[type]);

  return (
    <Modal
      open={open}
      title={renderTitle(title, type)}
      onCancel={() => handleCancelClick()}
      maskClosable={!isSaving}
      keyboard={!isSaving}
      centered
      closable={false}
      destroyOnClose
      className={`organizations-confirm-modal${
        hasIcon ? ' organizations-confirm-modal--with-icon' : ''
      }`}
      transitionName=""
      maskTransitionName=""
      footer={[
        <Button
          key="cancel"
          type={ButtonType.outline}
          onClick={() => handleCancelClick()}
          disabled={isSaving}
        >
          {cancelLabel}
        </Button>,
        <Button
          key="confirm"
          type={type === 'error' ? ButtonType.danger : ButtonType.primary}
          onClick={() => onConfirm()}
          loading={isSaving}
        >
          {confirmLabel}
        </Button>
      ]}
    >
      {children}
    </Modal>
  );
};

ConfirmModal.propTypes = {
  children: PropTypes.node.isRequired,
  close: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  confirmLabel: PropTypes.string,
  cancelLabel: PropTypes.string,
  isSaving: PropTypes.bool,
  type: PropTypes.oneOf([
    'basic',
    'confirmation',
    'warningConfirmation',
    'warning',
    'information',
    'error'
  ])
};

export default ConfirmModal;
